import { Link } from 'react-router';
import { siteMaintenanceText } from '../../constants/config';

const SiteMaintenance = () => {
  document.title = 'Unavailable service';

  return (
    <div className="govuk-grid-row">
      <div className="govuk-grid-column-full">
        <h1 className="govuk-heading-l" data-testid="landing-h1">
          Sorry, the service is unavailable
        </h1>
        {siteMaintenanceText && <p className="govuk-body">{siteMaintenanceText}</p>}
        <p className="govuk-body">
          If you need to submit a voyage report during the maintenance period, you should follow the
          instructions for{' '}
          <Link
            className="govuk-link"
            to="https://www.gov.uk/guidance/submit-a-pleasure-craft-report#submit-your-report--by-email"
          >
            submitting your report by email
          </Link>
          .
        </p>
        <p className="govuk-body">
          You can also download and complete a PDF version of the form and follow the instructions
          for{' '}
          <Link
            className="govuk-link"
            to="https://www.gov.uk/guidance/submit-a-pleasure-craft-report#submit-your-report-by-print-and-post"
          >
            submitting your voyage report by post
          </Link>
          .
        </p>
      </div>
    </div>
  );
};

export default SiteMaintenance;
